module.exports = __webpack_public_path__ + "static/assets/b5f0cc6dd8eaba87a4ad5c3c402a4db4.svg";